import { PageWithAsideLayout } from '@/components/client-layouts/page-with-aside-layout';
import FullscreenMessage from '@/components/ui/layout/fullscreen-message';
import LayoutBox1024 from '@/components/ui/layout/layout-1024-box';
import NonMobileAside from '@/components/vehicles/non-mobile-aside';
import NonMobileHeader from '@/components/vehicles/non-mobile-header';
import NonMobileMain from '@/components/vehicles/non-mobile-main';
import { useAuthContext } from '@/contexts/auth-context';
import useVehicleListing from '@/hooks/vehicle-listings/use-vehicle-listing';
import useVehicleListingId from '@/hooks/vehicle-listings/use-vehicle-listing-id';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

export const VehiclePage = observer(() => {
  const { listingId } = useVehicleListingId();
  const { vehicleListing: listing } = useVehicleListing(listingId);
  const { hasValidSession } = useAuthContext();

  if (!hasValidSession) {
    return (
      <FullscreenMessage>
        <div className="text-2xl">Your session has expired</div>
      </FullscreenMessage>
    );
  }

  if (!listing) {
    return (
      <FullscreenMessage>
        <div className="text-2xl">No Vehicle Found</div>
      </FullscreenMessage>
    );
  }

  return (
    <div className="h-full">
      <PageWithAsideLayout
        key={`vehicle-page-${listingId}`}
        mobile={{ header: null, subheader: null, aside: null, main: null }}
        nonMobile={{
          header: <NonMobileHeader listing={listing} />,
          aside: <NonMobileAside listing={listing} />,
          main: (
            <LayoutBox1024>
              <NonMobileMain listing={listing} />
            </LayoutBox1024>
          ),
        }}
      />
    </div>
  );
});

export const Route = createFileRoute('/(authenticated)/cars/$listingId/')({
  component: VehiclePage,
});
